import Vue from 'vue'
import Router from 'vue-router'
import Personal from './personal'

Vue.use(Router)


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


let RouteList = [{
    path: '/',
    component: resolve => require(['@/views/layout/App.vue'], resolve),
    meta: {
        title: '首页',
        keepAlive: false,
    },
    children: [{
        path: '/',
        name: 'Dashboard',
        meta: {
            title: '首页',
            keepAlive: true
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },

    //个人资料
    Personal.index,
    {
        path: '/',
        name: 'Home',
        meta: {
            title: '首页',
            keepAlive: false
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },
    {
        path: '/price_item',
        name: 'priceItem',
        meta: {
            title: '价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/price_item.vue'], resolve),
    },
    {
        path: '/user_list',
        name: 'userList',
        meta: {
            title: '用户列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/user_list.vue'], resolve),
    },
    {
        path: '/goods_order',
        name: 'goodsOrder',
        meta: {
            title: '影票订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/goods_order.vue'], resolve),
    },
    {
        path: '/cards_order',
        name: 'cardsOrder',
        meta: {
            title: '品城卡订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/cards_order.vue'], resolve),
    },
    // {
    //     path: '/settle_order',
    //     name: 'settleOrder',
    //     meta: {
    //         title: '结算订单',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/site/settle_order.vue'], resolve),
    // },
    {
        path: '/mahua_orders',
        name: 'mahuaOrders',
        meta: {
            title: '点餐订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/mahua_orders.vue'], resolve),
    },
    {
        path: '/local_order',
        name: 'localOrder',
        meta: {
            title: '本地生活订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/local_order.vue'], resolve),
    },
    {
        path: '/oil_orders',
        name: 'oilOrders',
        meta: {
            title: '油卡订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/oil_orders.vue'], resolve),
    },
    {
        path: '/tel_orders',
        name: 'telOrders',
        meta: {
            title: '话费订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/tel_orders.vue'], resolve),
    },
    {
        path: '/goods_orders',
        name: 'goodsorders',
        meta: {
            title: '电商订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/goods_orders.vue'], resolve),
    },

    {
        path: '/user_withdrawal',
        name: 'userWithdrawal',
        meta: {
            title: '用户提现',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/user_withdrawal.vue'], resolve),
    },
    {
        path: '/apl_records',
        name: 'aplRecords',
        meta: {
            title: '线下影城卡',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/apl_records.vue'], resolve),
    },
    {
        path: '/movie_card',
        name: 'movieCard',
        meta: {
            title: '我的影城卡',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/mine_cards.vue'], resolve),
    },
    {
        path: '/mine_account',
        name: 'mineAccount',
        meta: {
            title: '我的账户',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/account.vue'], resolve),
    },
    {
        path: '/mine_data',
        name: 'mineData',
        meta: {
            title: '站点资料',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/mineData.vue'], resolve),
    },
    {
        path: '/open_card',
        name: 'openCard',
        meta: {
            title: '线上品城卡',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/open_card.vue'], resolve),
    },
    {
        path: '/kefu',
        name: 'kefu',
        meta: {
            title: '客服中心',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/kefu.vue'], resolve),
    },
    {
        path: '/couponFf',
        name: 'couponFf',
        meta: {
            title: '优惠券投放',
            keepAlive: false
        },
        component: resolve => require(['@/views/coupon/coupon_ff.vue'], resolve),
    },
    {
        path: '/couponRecords',
        name: 'couponRecords',
        meta: {
            title: '券码记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/coupon/coupon_records.vue'], resolve),
    },
    {
        path: '/act_h5_coupon',
        name: 'act_h5_coupon',
        meta: {
            title: 'H5活动',
            keepAlive: false
        },
        component: resolve => require(['@/views/act/act_h5_coupon.vue'], resolve),
    },
    {
        path: '/act_miniapp_coupon',
        name: 'act_miniapp_coupon',
        meta: {
            title: '小程序活动',
            keepAlive: false
        },
        component: resolve => require(['@/views/act/act_miniapp_coupon.vue'], resolve),
    },
    {
        path: '/push',
        name: 'push',
        meta: {
            title: '公众号推文',
            keepAlive: false,
        },
        component: resolve => require(['@/views/push/push.vue'], resolve),
    },
    {
        path: '/patch',
        name: 'patch',
        meta: {
            title: '贴片管理',
            keepAlive: false,
        },
        component: resolve => require(['@/views/push/patch.vue'], resolve),
    },
    {
        path: '/recharge',
        name: 'recharge',
        meta: {
            title: '充值',
            keepAlive: false,
        },
        component: resolve => require(['@/views/recharge/recharge.vue'], resolve),
    },
    ]
},
{
    path: '/login',
    name: 'Login',
    meta: {
        title: '登录',
        keepAlive: false
    },
    components: {
        blank: resolve => require(['@/views/login/Login.vue'], resolve),
    }
},

{
    path: '/*',
    name: 'NotFound',
    meta: {
        title: '404',
        keepAlive: true
    },
    components: {
        blank: resolve => require(['@/views/error/404.vue'], resolve),
    }
}
]

export default new Router({
    routes: RouteList
})